import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { Users, Radio, Mic, Sliders, MonitorSpeaker, Upload, Wrench, Smartphone } from 'lucide-react'

/* Kempenvision-navigatie — één tabstrip die alle sub-routes bundelt.
   Zichtbare tabs afhankelijk van rol. Vroeger stonden alle Kempenvision-
   subpagina's als aparte sidebar-items; door ze hier te bundelen blijft de
   sidebar rustig én ziet de gebruiker in-context wat hij nog kan doen. */

const TABS = [
  { path: '/kempenvision',           label: 'Publiek',      icon: Users,          public: true },
  { path: '/kempenvision/inleveren', label: 'Inleveren',    icon: Upload,         public: true },
  { path: '/kempenvision/vote',      label: 'Stemmen',      icon: Radio,          public: true },
  { path: '/kempenvision/jury',      label: 'Jury',         icon: Mic,            juryOrAdmin: true },
  { path: '/kempenvision/control',   label: 'Regie',        icon: Sliders,        adminOrReferee: true },
  { path: '/kempenvision/touch',     label: 'Touch',        icon: Smartphone,     adminOrReferee: true },
  { path: '/kempenvision/midi',      label: 'MIDI',         icon: MonitorSpeaker, admin: true },
  { path: '/kempenvision/admin',     label: 'Setup',        icon: Wrench,         admin: true },
]

export default function KempenvisionNav() {
  const { user } = useAuth()
  const location = useLocation()
  const role = user?.role
  const isAdmin = role === 'admin' || role === 'superadmin'
  const isReferee = role === 'referee' || isAdmin
  const isJury = role === 'jury' || isAdmin

  const visible = TABS.filter(t => {
    if (t.public) return true
    if (t.admin) return isAdmin
    if (t.adminOrReferee) return isReferee
    if (t.juryOrAdmin) return isJury
    return false
  })

  return (
    <div className="border-b border-border mb-4">
      <div className="flex gap-1 overflow-x-auto -mb-px px-4 pt-2">
        {visible.map(tab => {
          const Icon = tab.icon
          const active = location.pathname === tab.path
          return (
            <Link
              key={tab.path}
              to={tab.path}
              className={`flex items-center gap-1.5 px-3 py-2 text-sm border-b-2 whitespace-nowrap transition-colors ${
                active
                  ? 'border-primary text-foreground'
                  : 'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
              }`}
            >
              <Icon size={14} /> {tab.label}
            </Link>
          )
        })}
      </div>
    </div>
  )
}
